import { render, staticRenderFns } from "./ListOfShareCapitalForApproveWithdrew.vue?vue&type=template&id=3f1fea67&"
import script from "./ListOfShareCapitalForApproveWithdrew.vue?vue&type=script&lang=js&"
export * from "./ListOfShareCapitalForApproveWithdrew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VChip,VIcon,VSimpleTable,VToolbar,VToolbarTitle})
